/**
 * Support FAQ Groups
 */

export class SupportFaqGroups {
  constructor() {
    this.component = document.querySelector(".wps-support-faq-groups");

    if (!this.component) {
      return;
    }

    this.sidebar = this.component.querySelector(".support-sidebar");
    this.content = this.component.querySelector(".support-content");

    this.links = this.component.querySelectorAll(".support-sidebar__link");
    this.sections = this.component.querySelectorAll(".support-section");

    this.init();
  }

  /**
   * Initialize
   */
  init() {
    this.bindEvents();
    this.updateActiveSection();
  }

  /**
   * Bind Events
   */
  bindEvents() {
    /**
     * FAQ Accordion
     */
    document.addEventListener("click", (e) => {
      const trigger = e.target.closest(".faq-item__trigger");

      if (trigger) {
        e.preventDefault();

        const item = trigger.closest(".faq-item");

        if (!item) {
          return;
        }

        const section = item.closest(".support-faqs");

        if (!section) {
          return;
        }

        const isOpen = item.classList.contains("is-open");

        section.querySelectorAll(".faq-item").forEach((faq) => {
          if (faq !== item) {
            this.closeItem(faq);
          }
        });

        if (isOpen) {
          this.closeItem(item);
        } else {
          this.openItem(item);
        }

        return;
      }

      /**
       * Sidebar Navigation
       */
      const link = e.target.closest(".support-sidebar__link");

      if (link) {
        e.preventDefault();

        const target = document.querySelector(link.getAttribute("href"));

        if (!target) {
          return;
        }

        const offset = 100;

        const y =
          target.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
          top: y,
          behavior: "smooth",
        });

        return;
      }
    });

    window.addEventListener("scroll", () => {
      this.updateActiveSection();
    });

    window.addEventListener("resize", () => {
      this.updateActiveSection();
    });
  }

  /**
   * Open FAQ
   */
  openItem(item) {
    const content = item.querySelector(".faq-item__content");
    const trigger = item.querySelector(".faq-item__trigger");

    item.classList.add("is-open");
    trigger.setAttribute("aria-expanded", "true");

    gsap.set(content, {
      display: "block",
      overflow: "hidden",
    });

    gsap.fromTo(
      content,
      {
        height: 0,
      },
      {
        height: "auto",
        duration: 0.4,
        ease: "power2.out",
      },
    );
  }

  /**
   * Close FAQ
   */
  closeItem(item) {
    const content = item.querySelector(".faq-item__content");
    const trigger = item.querySelector(".faq-item__trigger");

    item.classList.remove("is-open");
    trigger.setAttribute("aria-expanded", "false");

    gsap.to(content, {
      height: 0,
      duration: 0.35,
      ease: "power2.out",
      onComplete: () => {
        gsap.set(content, {
          display: "none",
        });
      },
    });
  }

  /**
   * Update Active Sidebar Link
   */
  updateActiveSection() {
    const trigger = window.innerHeight * 0.3;

    let activeSection = null;

    this.sections.forEach((section) => {
      const rect = section.getBoundingClientRect();

      if (rect.top <= trigger && rect.bottom >= trigger) {
        activeSection = section.id;
      }
    });

    this.links.forEach((link) => {
      link.classList.toggle(
        "is-active",
        link.getAttribute("href") === `#${activeSection}`,
      );
    });
  }
}
